import { signOut } from '../utils';

import Account from '../components/common/icon/Account';
import Bankbook from '../components/common/icon/Bankbook';
import Earning from '../components/common/icon/Earning';
import Payout from '../components/common/icon/Payout';
import FileUpload from '../components/common/icon/FileUpload';
import Portfolio from '../components/common/icon/Portfolio';
import PortfolioSubmit from '../components/common/icon/PortfolioSubmit';
import PortfolioReview from '../components/common/icon/PortfolioReview';
import PortfolioPending from '../components/common/icon/PortfolioPending';

export const ACCOUNT_MANAGEMENT_MENU = [
  {
    label_ko: '계정 및 프로필',
    label_en: 'Account & Profile',
    lang_code: 'header_account_dropdown_label_1',
    type: 'link',
    path: '/mypage',
    tab: 0,
    isShow: true,
    icon: <Account />,
  },
  {
    label_ko: '지급 정보',
    label_en: 'Payment Information',
    lang_code: 'header_account_dropdown_label_2',
    type: 'link',
    path: '/payment',
    tab: 1,
    isShow: true,
    icon: <Bankbook />,
  },
  {
    label_ko: '로그아웃',
    label_en: 'Sign out',
    lang_code: 'header_account_dropdown_label_3',
    type: 'function',
    action: () => signOut(),
    isShow: false,
  },
];

export const EARNING_MENU = [
  {
    label_ko: '수익 요약',
    label_en: 'Overview',
    lang_code: 'dashboard30_text_4',
    path: '/earning',
    isShow: true,
    icon: <Earning />,
  },
  {
    label_ko: '지급 내역',
    label_en: 'Payment History',
    lang_code: 'dashboard30_text_5',
    path: '/payout',
    isShow: true,
    icon: <Payout />,
  },
];

export const UPLOAD_MENU = [
  {
    label_ko: '업로드',
    label_en: 'Upload',
    path: '/upload',
    lang_code: 'dashboard30_text_7',
    isShow: true,
    icon: <FileUpload />,
  },
  {
    label_ko: '제출 예정',
    label_en: 'Submission',
    lang_code: 'dashboard30_text_8',
    judge_code: 'judge_sentence_1',
    path: '/submit',
    isShow: true,
    icon: <PortfolioSubmit />,
  },
  {
    label_ko: '검수 중',
    label_en: 'Under Review',
    lang_code: 'dashboard30_text_9',
    judge_code: 'judge_sentence_2',
    path: '/review',
    isShow: true,
    icon: <PortfolioReview />,
  },
  {
    label_ko: '보류 중',
    label_en: 'Pending Approval',
    lang_code: 'dashboard30_text_10',
    judge_code: 'judge_sentence_3',
    path: '/pending',
    isShow: true,
    icon: <PortfolioPending />,
  },
  {
    label_ko: '사용 허가서',
    label_en: 'Release',
    lang_code: 'dashboard30_text_11',
    path: '/release',
    isShow: true,
    icon: <PortfolioPending />,
  },
];
